import * as vp from 'vopay';
import * as Yup from 'yup';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import useBuildUpdateInveriteRows from './buildUpdateInveriteRows.helper';
import { useTranslation } from 'react-i18next';

const { Box, Button, Title, Table, TextField } = vp;

type UpdateInveriteProps = {
  onSubmit: (params: vp.SetInveriteCredentialsRequest) => void;
  defaultValues: vp.SetInveriteCredentialsRequest;
};
type FC = FunctionComponent<UpdateInveriteProps>;

const UpdateInverite: FC = (props: UpdateInveriteProps) => {
  const { onSubmit, defaultValues } = props;
  const updateInveriteRows = useBuildUpdateInveriteRows();
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Inverite.Update.Form' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  return (
    <Formik
      enableReinitialize
      initialValues={defaultValues}
      onSubmit={onSubmit}
      validationSchema={createdValidationSchema()}
      validateOnChange
      validateOnBlur
    >
      {({ values, touched, errors, handleChange, handleBlur, handleSubmit }) => {
        const updateInveriteTable: vp.TableProps = {
          name: 'update-inverite-fields',
          variant: 'pair',
          columns: {
            Field: { header: 'Labels' },
            Input: { header: 'Fields' },
          },
          rows: updateInveriteRows.map(({ label, id, preset }) => ({
            Field: label,
            Input: (
              <TextField
                preset={preset}
                key={id}
                name={id}
                variant="standard"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values[id]}
                error={errors[id] && touched[id] ? errors[id] : null}
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box mb="md" jc="sb">
              <Title title={t('pageTitle')} />
            </Box>
            <Table {...updateInveriteTable} />
            <Box mt="md" jc="fe">
              <Button id="Inverite-review" type="submit" label={tGlobal('Buttons.update')} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
  function createdValidationSchema() {
    return Yup.object().shape({
      InveriteAPIKey: Yup.string()
        .label(t('inveriteApiKey'))
        .required()
        .matches(/^.*\S+.*/, t('whiteSpaceValidation')),
      InveriteUrl: Yup.string()
        .label(t('inveriteUrl'))
        .required()
        .matches(/^.*\S+.*/, t('whiteSpaceValidation')),
    });
  }
};

export default UpdateInverite;
